import analytics from 'src/tracking/analytics';

export const trackOpenPropertiesVideoExpandy = () => analytics.track('Properties Explainer Video Expandy Click', { action: 'Open' });
export const trackClosePropertiesVideoExpandy = () => analytics.track('Properties Explainer Video Expandy Click', { action: 'Close' });
